// templates/PageTemplate.tsx
import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import Banner, { BannerProps } from '../../components/Banner'
import { HtmlProps } from '../../components/Html'
import MediaComponent, { MediaProps } from '../../components/MediaComponent'

import * as SC from './styled'

export type PageTemplateProps = {
  className?: string
  layoutProps?: DefaultLayoutProps
  banner: BannerProps
  html: HtmlProps
  media?: MediaProps
  isMediaAtTop?: boolean
}

const PageTemplate: FC<PageTemplateProps> = ({
  layoutProps,
  banner,
  html,
  media,
  isMediaAtTop = true,
}) => {
  return (
    <DefaultLayout {...layoutProps}>
      <SC.Content>
        <Banner {...banner} />
        {media && isMediaAtTop && <MediaComponent {...media} className="media-top" />}
        <SC.BoxedContent>
          <SC.HTML {...html} />
        </SC.BoxedContent>
        {media && !isMediaAtTop && <SC.BottomMediaComponent {...media} className="media-bottom" />}
      </SC.Content>
    </DefaultLayout>
  )
}

export default PageTemplate
